export const BASE_URL = "https://api-store.nextlead.ma"
// export const BASE_URL = "https://api-manager.topselleraffiliate.ma"
// export const EXTERNAL_BASE_URL = "http://127.0.0.1:8001"
// export const BASE_URL = "http://127.0.0.1:8000"
// export const BASE_URL = "https://api-store.zumbapro.ma"
export const EXTERNAL_BASE_URL = ""


export const NAME = "nextlead"
// export const NAME = "bousskssou"
// export const NAME = "topseller"

